import PropTypes from 'prop-types';
import equals from "ramda/es/equals";
import reject from "ramda/es/reject";
import cx from "ramda-extension/es/cx";
import isFunction from "ramda-extension/es/isFunction";
import React, { Component } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { withDefaultComponentProps } from '../../../decorators/withDefaultComponentProps';
const COMPONENT_NAME = 'Textarea';
class Textarea extends Component {
    shouldComponentUpdate(nextProps) {
        return !equals(reject(isFunction, this.props), reject(isFunction, nextProps));
    }
    render() {
        const { id, disabled, autoComplete, className, rows, value, onChange, ...other } = this.props;
        return /*#__PURE__*/ React.createElement(TextareaAutosize, {
            ref: (ref)=>{
                this._area = ref;
            },
            id: id,
            disabled: disabled,
            autoComplete: autoComplete === 'workaround-off' ? `new-${id}` : autoComplete,
            className: cx('Textarea', className),
            minRows: rows,
            value: value,
            onChange: onChange,
            ...other
        });
    }
}
Textarea.propTypes = {
    autoComplete: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    onChange: PropTypes.func,
    rows: PropTypes.number,
    value: PropTypes.any
};
export { Textarea };
export default withDefaultComponentProps(COMPONENT_NAME, {
    rows: 1,
    autoComplete: 'workaround-off'
}, Textarea);
